<template>
	<div class="number-range-item" :width="width" :heigth="height" :style="_style">
		<el-input
			v-model="value[0]"
			:placeholder="placeHolder[0]"
			@input="inputStart"
			@change="changeStart"
			@blur="blurStart"
		></el-input>
		<span class="range-separator">{{rangeSeparator}}</span>
		<el-input
			v-model="value[1]"
			:placeholder="placeHolder[1]"
			@input="inputEnd"
			@change="changeEnd"
			@blur="blurEnd"
		></el-input>
	</div>
</template>

<script>
export default {
	name: "number-range-item",
	props: {
		value: {
			type: Array,
			default: function() {
				return [];
			}
		},
		rangeSeparator: {
			type: String,
			default: "-"
		},
		placeHolder: {
			type: Array,
			default: function() {
				return ["最小值", "最大值"];
			}
		},
		width: {
			type: String,
			default: "280px"
		},
		height: {
			type: String,
			default: "40px"
		},
		styleSheet: {
			type: Object,
			default: function() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {};
	},
	computed: {
		_value: {
			get() {
				return this.value;
			},
			set(val) {
				console.log(val);
				this.$emit("input", val);
			}
		},
		_style() {
			return Object.assign(
				{},
				{
					width: this.width,
					height: this.height,
					"line-height": this.height
				},
				this.styleSheet
			);
		}
	},

	methods: {
		inputStart(val) {
			const ret = [val, this.value[1]];
			this.$emit("input", ret);
		},
		inputEnd(val) {
			const ret = [this.value[0], val];
			this.$emit("input", ret);
		},
		changeStart(val) {
			const ret = [val, this.value[1]];
			this.$emit("change", ret);
		},
		changeEnd(val) {
			const ret = [this.value[0], val];
			this.$emit("change", ret);
		},
		blurStart(val) {
			const ret = [val, this.value[1]];
			this.$emit("blur", ret);
		},
		blurEnd(val) {
			const ret = [this.value[0], val];
			this.$emit("blur", ret);
		}
	},
	created() {},
	mounted() {}
};
</script>
<style lang='scss' scoped>
::v-deep.number-range-item {
	border: 1px solid #dfe3e5;
	border-radius: 16px;
	display: flex;
	.el-input__inner {
		height: auto;
		line-height: normal;
		border: none;
		border-radius: 16px;
		text-align: center;
	}
	.range-separator {
		color: rgba(0, 0, 0, 0.65);
	}
	::-webkit-input-placeholder {
		text-align: center;
	}
}
</style>